import React from 'react';
import { heroData } from '../data/mock';
import { ChevronDown } from 'lucide-react';
import heroBg from '../assets/hero-background-students-university.webp';

const HeroSection = () => {
  const scrollToAbout = () => {
    const element = document.getElementById('about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${heroBg})`,
        }}
      />

      {/* Orange gradient overlay – escurece progressivamente */}
      <div
        className="absolute inset-0 bg-gradient-to-b 
    from-[#D97A3A]/85 
    via-[#C96A2D]/90 
    to-[#8F4416]/100"
      />
       {/* Subtle geometric pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-64 h-64 border-2 border-white/40 rounded-full" />
        <div className="absolute bottom-20 right-10 w-96 h-96 border-2 border-white/30 rounded-full" />
        <div className="absolute top-1/3 right-1/4 w-48 h-48 border-2 border-white/20 rotate-45" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Title */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-8 leading-tight drop-shadow-lg">
          {heroData.title}
        </h1>

        {/* Subtitle */}
        <p className="text-xl md:text-2xl lg:text-3xl text-white/95 max-w-4xl mx-auto leading-relaxed font-light drop-shadow-md">
          {heroData.subtitle}
        </p>

        {/* CTA Button - Inverted style */}
        <div className="mt-12">
          <button
            onClick={scrollToAbout}
            className="inline-flex items-center gap-2 bg-white text-[#DA8347] px-10 py-5 rounded-xl font-bold text-lg transition-all duration-300 hover:bg-gray-100 hover:shadow-2xl hover:-translate-y-1 shadow-lg"
          >
            Conhecer o IPTGE
            <ChevronDown size={22} />
          </button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <ChevronDown className="text-white/80" size={36} />
      </div>
    </section>
  );
};

export default HeroSection;
